import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { TAGS_QUERY_KEY } from "./useTags";

export type DeleteTagVariables = {
  tagId: string;
};

export function useDeleteTag() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteTagVariables>({
    mutationFn: async ({ tagId }) => {
      const { error } = await client.DELETE("/api/tags/{tag_id}", {
        params: { path: { tag_id: tagId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to delete tag ${tagId}`);
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
    },
  });
}
